/**
 * Classe servant à l'envoi de mail
 */
export class Message {
  nomEtPrenom: string;
  telephone: string;
  email: string;
  message: string;
}
